import { useEffect, useState } from "react";
import api from "../../apis";


const useData = (type?: string) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    setData([]);
    // 示例请求
    api.post(`/yunditu/admin/index.php?d=api&c=yewu&m=getDituList`, { type, pagesize: 100 })
    .then((res: any) => {
      console.log('响应数据:', data);
      setData(res.data);
    })
    .catch(error => {
      console.error('发生错误:', error);
    });

  }, [type]);

  return data;
  
}

export default useData;




